/**
 * Combine any number of truthy args in a string joined by a space
 *
 * All falsy values passed in are ignored and the remaining values are stringified before joining
 *
 * @param  {...any} [strs=[]] A variadic number of values
 * @returns {string} A string of all the truthy values joined with a space
 */
export const words = (...strs) => strs.filter(Boolean).map(String).join(' ');
